import { cn } from 'noddi-ui-common';

type Props = {
  /** Size the dot with `size-*`; the ring follows. */
  className?: string;
};

/**
 * Marks something as live or in flight right now: a solid dot under an expanding ring. The ring is
 * what pulses, and it stops for reduced motion.
 */
export const NavioLiveDot = ({ className }: Props) => (
  <span aria-hidden className={cn('relative flex size-2 shrink-0', className)}>
    <span className='absolute inline-flex size-full animate-ping rounded-full bg-success opacity-75 motion-reduce:hidden' />
    <span className='relative inline-flex size-full rounded-full bg-success' />
  </span>
);
